import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';
import { SingleResponseModel } from '../../../../common/models/single-response.model';
import { SummaryInvestmentAssetIntangibleModel } from '../../models/summary-investment-asset-intangible.model';
import { InvestmentAssetIntangibleActions, InvestmentAssetIntangibleActionTypes, LoadInvestmentAssetIntangiblesSuccess } from '../actions/investment-asset-intangible.actions';


export interface InvestmentAssetIntangibleState {
  items: SummaryInvestmentAssetIntangibleModel[];
  total: number;
  res: PaginableResponseModel<SummaryInvestmentAssetIntangibleModel>;
  selected: SingleResponseModel<SummaryInvestmentAssetIntangibleModel> | null;
  loading: boolean;
  error: any
}


export const initalState: InvestmentAssetIntangibleState = {
  items: [],
  total: 0,
  res: null,
  selected: null,
  loading: false,
  error: null
};

export function InvestmentAssetIntangibleReducer(
  state = initalState,
  action: InvestmentAssetIntangibleActions
): InvestmentAssetIntangibleState {

  switch (action.type) {
    case InvestmentAssetIntangibleActionTypes.LoadInvestmentAssetIntangibles:
      return { ...state, loading: true, error: null };

    case InvestmentAssetIntangibleActionTypes.LoadInvestmentAssetIntangiblesSuccess:
      const { items, total } = (action as LoadInvestmentAssetIntangiblesSuccess).payload;
      return {
             ...state,
             loading: false,
             error: null,
             items: items,
             total: total,
           };
    case InvestmentAssetIntangibleActionTypes.LoadInvestmentAssetIntangiblesFailure:
      return{ ...state, loading: false, error: action.payload.error };


    case InvestmentAssetIntangibleActionTypes.LoadInvestmentAssetIntangibleSuccess:
      return {
        ...state,
        selected: action.payload
      };

    default:
      return state;
  }
}
